// src/auth/TokenProbe.jsx
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { irAlLogin, sesionMuerta } from "./SessionGate";

export default function TokenProbe() {
  const { getAccessTokenSilently, loginWithRedirect, isLoading } = useAuth0();

  useEffect(() => {
    if (isLoading) return;

    const probe = async (label) => {
      try {
        // Force a real token fetch (will use refresh token first)
        await getAccessTokenSilently({ cacheMode: "off" });
        // If this succeeds, RT is still good — do nothing
        console.log(`[TokenProbe] ${label}: RT ok`);
      } catch (e) {
        // Un error pasajero (red, timeout) no es sesión vencida: la próxima vez
        // que vuelva a la pestaña se verifica de nuevo.
        if (!sesionMuerta(e)) {
          console.log(`[TokenProbe] ${label}: error pasajero, no se redirige`, e?.error || e);
          return;
        }
        console.log(`[TokenProbe] ${label}: RT expired → redirecting`, e.error);
        // DO NOT try ignoreCache/iframe here — go straight to login.
        // Con returnTo, para volver a la misma página, y con prompt=login (ver irAlLogin).
        await irAlLogin(loginWithRedirect, { conCredenciales: true });
      }
    };

    // Al cargar ya verificó SessionGate, antes de pintar nada. Acá queda solo
    // la verificación al volver a la pestaña.
    const onFocus = () => probe("focus");
    const onVisible = () => document.visibilityState === "visible" && probe("visible");
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [getAccessTokenSilently, loginWithRedirect, isLoading]);

  return null;
}
